import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MetersBlock from '../../../../../components/ui/MetersBlock/MetersBlock';
import useFlatMeters from '../../../../../queries/useFlatMeters';
import useChangeMeterModalVisible from '../../../../../hooks/useChangeMeterModalVisible';
import styles from '../Flat.module.scss';

const FlatMeters = () => {
  const params = useParams();

  const addressId = Number(params.pageTabId);

  const { open: openMeterModal } = useChangeMeterModalVisible();

  const { CanEditIndividualMeters: canAdd } =
    useSelector((state) => state.authentication.userInfo) || {};

  const { data: meters, isFetching: isMetersFetching } =
    useFlatMeters(addressId);

  return (
    <MetersBlock
      className={styles.grow}
      meters={meters}
      loading={isMetersFetching}
      onInfoClick={({ meter }) =>
        openMeterModal({ isInfo: true, meter, addressId })
      }
      onAddBtnClick={
        canAdd ? () => openMeterModal({ isInfo: false, addressId }) : undefined
      }
    />
  );
};

export default FlatMeters;
